"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
const types_1 = require("@comunica/types");
class Operator {
    name;
    args;
    apply;
    expressionType = types_1.ExpressionType.Operator;
    constructor(name, args, apply) {
        this.name = name;
        this.args = args;
        this.apply = apply;
    }
}
exports.Operator = Operator;
//# sourceMappingURL=Operator.js.map